import type {RightName} from '@/types/api/right.type'
import type Right from '@/types/api/right.type'

const hasRolePermission = (rights: Right[], allowedRole: RightName): boolean => {
  return rights.filter(right => right.name === allowedRole).length > 0
}

export {hasRolePermission}
